import styled from '@emotion/styled'
import { GridRow } from '@mobi/component-library/Legacy/Grid'
import { hexColors } from '@mobi/settings/hexColors'

export const RaceListHeaderStyled = styled.header({
  alignItems: 'center',
  background: hexColors.nero,
  boxSizing: 'border-box',
  color: hexColors.white,
  display: 'flex',
  justifyContent: 'center',
  lineHeight: 2,
  padding: '0.5em 1.2em 1em 1.2em',
  textAlign: 'center',
  width: '100%',
})

export const RaceListHeaderDetails = styled(GridRow)({
  color: hexColors.gainsboro,
  fontSize: '1.1rem',
  lineHeight: '3rem',
  textTransform: 'uppercase',
})

export const RaceListCenteredHeaderStyled = styled.div({
  maxWidth: '42rem',
  width: '100%',
})
